import * as React from 'react';

function SvgReconciliationApprove(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#4A90E2" cx={24} cy={24} r={24} />
        <path
          d="M28.931 15a2 2 0 012 2v5.277a7.241 7.241 0 00-7.363 10.103H17a2 2 0 01-2-2V17a2 2 0 012-2h11.931zm1.276 8.69a5.793 5.793 0 110 11.586 5.793 5.793 0 010-11.586zm.222 3.053c-.521 0-.943.388-.943.867v2.552l.007.11a.827.827 0 00.24.473.832.832 0 00.62.284h2.552l.1-.007c.432-.054.766-.453.766-.936l-.005-.11c-.05-.47-.417-.833-.861-.833l-1.534-.001V27.61l-.006-.102c-.054-.43-.453-.765-.936-.765zm-11.551-6.819h8.175c.542 0 .981-.389.981-.869s-.439-.869-.98-.869h-8.176c-.542 0-.981.39-.981.87s.439.868.98.868zm-.112 4.055h3.62a.869.869 0 100-1.738h-3.62a.869.869 0 100 1.738z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgReconciliationApprove;
